import { lazy, LazyExoticComponent, ComponentType, SVGProps } from 'react'

type Web3IconType = ComponentType<
  SVGProps<SVGSVGElement> & {
    size?: number | string
    variant?: 'mono' | 'branded'
    color?: string
  }
>

export const iconMap: Record<string, LazyExoticComponent<Web3IconType>> = {
  APE: lazy(() =>
    import(/* webpackExports: ["TokenAPE"] */ '@web3icons/react').then(m => ({
      default: m.TokenAPE as unknown as Web3IconType,
    })),
  ),
  ATRI: lazy(() =>
    import(/* webpackExports: ["TokenATRI"] */ '@web3icons/react').then(m => ({
      default: m.TokenATRI as unknown as Web3IconType,
    })),
  ),
  AUDIO: lazy(() =>
    import(/* webpackExports: ["TokenAUDIO"] */ '@web3icons/react').then(m => ({
      default: m.TokenAUDIO as unknown as Web3IconType,
    })),
  ),
  BAT: lazy(() =>
    import(/* webpackExports: ["TokenBAT"] */ '@web3icons/react').then(m => ({
      default: m.TokenBAT as unknown as Web3IconType,
    })),
  ),
  BLUR: lazy(() =>
    import(/* webpackExports: ["TokenBLUR"] */ '@web3icons/react').then(m => ({
      default: m.TokenBLUR as unknown as Web3IconType,
    })),
  ),
  BNT: lazy(() =>
    import(/* webpackExports: ["TokenBNT"] */ '@web3icons/react').then(m => ({
      default: m.TokenBNT as unknown as Web3IconType,
    })),
  ),
  CGG: lazy(() =>
    import(/* webpackExports: ["TokenCGG"] */ '@web3icons/react').then(m => ({
      default: m.TokenCGG as unknown as Web3IconType,
    })),
  ),
  COW: lazy(() =>
    import(/* webpackExports: ["TokenCOW"] */ '@web3icons/react').then(m => ({
      default: m.TokenCOW as unknown as Web3IconType,
    })),
  ),
  CWS: lazy(() =>
    import(/* webpackExports: ["TokenCWS"] */ '@web3icons/react').then(m => ({
      default: m.TokenCWS as unknown as Web3IconType,
    })),
  ),
  DAI: lazy(() =>
    import(/* webpackExports: ["TokenDAI"] */ '@web3icons/react').then(m => ({
      default: m.TokenDAI as unknown as Web3IconType,
    })),
  ),
  DAO: lazy(() =>
    import(/* webpackExports: ["TokenDAO"] */ '@web3icons/react').then(m => ({
      default: m.TokenDAO as unknown as Web3IconType,
    })),
  ),
  DC: lazy(() =>
    import(/* webpackExports: ["TokenDC"] */ '@web3icons/react').then(m => ({
      default: m.TokenDC as unknown as Web3IconType,
    })),
  ),
  DERC: lazy(() =>
    import(/* webpackExports: ["TokenDERC"] */ '@web3icons/react').then(m => ({
      default: m.TokenDERC as unknown as Web3IconType,
    })),
  ),
  DGX: lazy(() =>
    import(/* webpackExports: ["TokenDGX"] */ '@web3icons/react').then(m => ({
      default: m.TokenDGX as unknown as Web3IconType,
    })),
  ),
  DMT: lazy(() =>
    import(/* webpackExports: ["TokenDMT"] */ '@web3icons/react').then(m => ({
      default: m.TokenDMT as unknown as Web3IconType,
    })),
  ),
  DYDX: lazy(() =>
    import(/* webpackExports: ["TokenDYDX"] */ '@web3icons/react').then(m => ({
      default: m.TokenDYDX as unknown as Web3IconType,
    })),
  ),
  EFI: lazy(() =>
    import(/* webpackExports: ["TokenEFI"] */ '@web3icons/react').then(m => ({
      default: m.TokenEFI as unknown as Web3IconType,
    })),
  ),
  ELAND: lazy(() =>
    import(/* webpackExports: ["TokenELAND"] */ '@web3icons/react').then(m => ({
      default: m.TokenELAND as unknown as Web3IconType,
    })),
  ),
  ENJ: lazy(() =>
    import(/* webpackExports: ["TokenENJ"] */ '@web3icons/react').then(m => ({
      default: m.TokenENJ as unknown as Web3IconType,
    })),
  ),
  ENS: lazy(() =>
    import(/* webpackExports: ["TokenENS"] */ '@web3icons/react').then(m => ({
      default: m.TokenENS as unknown as Web3IconType,
    })),
  ),
  ERN: lazy(() =>
    import(/* webpackExports: ["TokenERN"] */ '@web3icons/react').then(m => ({
      default: m.TokenERN as unknown as Web3IconType,
    })),
  ),
  ETH: lazy(() =>
    import(/* webpackExports: ["TokenETH"] */ '@web3icons/react').then(m => ({
      default: m.TokenETH as unknown as Web3IconType,
    })),
  ),
  FEI: lazy(() =>
    import(/* webpackExports: ["TokenFEI"] */ '@web3icons/react').then(m => ({
      default: m.TokenFEI as unknown as Web3IconType,
    })),
  ),
  FRAX: lazy(() =>
    import(/* webpackExports: ["TokenFRAX"] */ '@web3icons/react').then(m => ({
      default: m.TokenFRAX as unknown as Web3IconType,
    })),
  ),
  FTM: lazy(() =>
    import(/* webpackExports: ["TokenFTM"] */ '@web3icons/react').then(m => ({
      default: m.TokenFTM as unknown as Web3IconType,
    })),
  ),
  FXS: lazy(() =>
    import(/* webpackExports: ["TokenFXS"] */ '@web3icons/react').then(m => ({
      default: m.TokenFXS as unknown as Web3IconType,
    })),
  ),
  GALA: lazy(() =>
    import(/* webpackExports: ["TokenGALA"] */ '@web3icons/react').then(m => ({
      default: m.TokenGALA as unknown as Web3IconType,
    })),
  ),
  GAME: lazy(() =>
    import(/* webpackExports: ["TokenGAME"] */ '@web3icons/react').then(m => ({
      default: m.TokenGAME as unknown as Web3IconType,
    })),
  ),
  GNO: lazy(() =>
    import(/* webpackExports: ["TokenGNO"] */ '@web3icons/react').then(m => ({
      default: m.TokenGNO as unknown as Web3IconType,
    })),
  ),
  GUSD: lazy(() =>
    import(/* webpackExports: ["TokenGUSD"] */ '@web3icons/react').then(m => ({
      default: m.TokenGUSD as unknown as Web3IconType,
    })),
  ),
  HORD: lazy(() =>
    import(/* webpackExports: ["TokenHORD"] */ '@web3icons/react').then(m => ({
      default: m.TokenHORD as unknown as Web3IconType,
    })),
  ),
  HOT: lazy(() =>
    import(/* webpackExports: ["TokenHOT"] */ '@web3icons/react').then(m => ({
      default: m.TokenHOT as unknown as Web3IconType,
    })),
  ),
  ICE: lazy(() =>
    import(/* webpackExports: ["TokenICE"] */ '@web3icons/react').then(m => ({
      default: m.TokenICE as unknown as Web3IconType,
    })),
  ),
  ID: lazy(() =>
    import(/* webpackExports: ["TokenID"] */ '@web3icons/react').then(m => ({
      default: m.TokenID as unknown as Web3IconType,
    })),
  ),
  ILV: lazy(() =>
    import(/* webpackExports: ["TokenILV"] */ '@web3icons/react').then(m => ({
      default: m.TokenILV as unknown as Web3IconType,
    })),
  ),
  IMX: lazy(() =>
    import(/* webpackExports: ["TokenIMX"] */ '@web3icons/react').then(m => ({
      default: m.TokenIMX as unknown as Web3IconType,
    })),
  ),
  KP3R: lazy(() =>
    import(/* webpackExports: ["TokenKP3R"] */ '@web3icons/react').then(m => ({
      default: m.TokenKP3R as unknown as Web3IconType,
    })),
  ),
  LINK: lazy(() =>
    import(/* webpackExports: ["TokenLINK"] */ '@web3icons/react').then(m => ({
      default: m.TokenLINK as unknown as Web3IconType,
    })),
  ),
  LOOKS: lazy(() =>
    import(/* webpackExports: ["TokenLOOKS"] */ '@web3icons/react').then(m => ({
      default: m.TokenLOOKS as unknown as Web3IconType,
    })),
  ),
  LUSD: lazy(() =>
    import(/* webpackExports: ["TokenLUSD"] */ '@web3icons/react').then(m => ({
      default: m.TokenLUSD as unknown as Web3IconType,
    })),
  ),
  LYXE: lazy(() =>
    import(/* webpackExports: ["TokenLYXE"] */ '@web3icons/react').then(m => ({
      default: m.TokenLYXE as unknown as Web3IconType,
    })),
  ),
  MANA: lazy(() =>
    import(/* webpackExports: ["TokenMANA"] */ '@web3icons/react').then(m => ({
      default: m.TokenMANA as unknown as Web3IconType,
    })),
  ),
  MATIC: lazy(() =>
    import(/* webpackExports: ["TokenMATIC"] */ '@web3icons/react').then(m => ({
      default: m.TokenMATIC as unknown as Web3IconType,
    })),
  ),
  MC: lazy(() =>
    import(/* webpackExports: ["TokenMC"] */ '@web3icons/react').then(m => ({
      default: m.TokenMC as unknown as Web3IconType,
    })),
  ),
  MEME: lazy(() =>
    import(/* webpackExports: ["TokenMEME"] */ '@web3icons/react').then(m => ({
      default: m.TokenMEME as unknown as Web3IconType,
    })),
  ),
  META: lazy(() =>
    import(/* webpackExports: ["TokenMETA"] */ '@web3icons/react').then(m => ({
      default: m.TokenMETA as unknown as Web3IconType,
    })),
  ),
  METIS: lazy(() =>
    import(/* webpackExports: ["TokenMETIS"] */ '@web3icons/react').then(m => ({
      default: m.TokenMETIS as unknown as Web3IconType,
    })),
  ),
  MFT: lazy(() =>
    import(/* webpackExports: ["TokenMFT"] */ '@web3icons/react').then(m => ({
      default: m.TokenMFT as unknown as Web3IconType,
    })),
  ),
  MKR: lazy(() =>
    import(/* webpackExports: ["TokenMKR"] */ '@web3icons/react').then(m => ({
      default: m.TokenMKR as unknown as Web3IconType,
    })),
  ),
  MONA: lazy(() =>
    import(/* webpackExports: ["TokenMONA"] */ '@web3icons/react').then(m => ({
      default: m.TokenMONA as unknown as Web3IconType,
    })),
  ),
  NCT: lazy(() =>
    import(/* webpackExports: ["TokenNCT"] */ '@web3icons/react').then(m => ({
      default: m.TokenNCT as unknown as Web3IconType,
    })),
  ),
  PDEX: lazy(() =>
    import(/* webpackExports: ["TokenPDEX"] */ '@web3icons/react').then(m => ({
      default: m.TokenPDEX as unknown as Web3IconType,
    })),
  ),
  POLS: lazy(() =>
    import(/* webpackExports: ["TokenPOLS"] */ '@web3icons/react').then(m => ({
      default: m.TokenPOLS as unknown as Web3IconType,
    })),
  ),
  PRIME: lazy(() =>
    import(/* webpackExports: ["TokenPRIME"] */ '@web3icons/react').then(m => ({
      default: m.TokenPRIME as unknown as Web3IconType,
    })),
  ),
  PSP: lazy(() =>
    import(/* webpackExports: ["TokenPSP"] */ '@web3icons/react').then(m => ({
      default: m.TokenPSP as unknown as Web3IconType,
    })),
  ),
  PUSH: lazy(() =>
    import(/* webpackExports: ["TokenPUSH"] */ '@web3icons/react').then(m => ({
      default: m.TokenPUSH as unknown as Web3IconType,
    })),
  ),
  QUARTZ: lazy(() =>
    import(/* webpackExports: ["TokenQUARTZ"] */ '@web3icons/react').then(m => ({
      default: m.TokenQUARTZ as unknown as Web3IconType,
    })),
  ),
  RARE: lazy(() =>
    import(/* webpackExports: ["TokenRARE"] */ '@web3icons/react').then(m => ({
      default: m.TokenRARE as unknown as Web3IconType,
    })),
  ),
  RARI: lazy(() =>
    import(/* webpackExports: ["TokenRARI"] */ '@web3icons/react').then(m => ({
      default: m.TokenRARI as unknown as Web3IconType,
    })),
  ),
  RBN: lazy(() =>
    import(/* webpackExports: ["TokenRBN"] */ '@web3icons/react').then(m => ({
      default: m.TokenRBN as unknown as Web3IconType,
    })),
  ),
  REVV: lazy(() =>
    import(/* webpackExports: ["TokenREVV"] */ '@web3icons/react').then(m => ({
      default: m.TokenREVV as unknown as Web3IconType,
    })),
  ),
  RFOX: lazy(() =>
    import(/* webpackExports: ["TokenRFOX"] */ '@web3icons/react').then(m => ({
      default: m.TokenRFOX as unknown as Web3IconType,
    })),
  ),
  RSR: lazy(() =>
    import(/* webpackExports: ["TokenRSR"] */ '@web3icons/react').then(m => ({
      default: m.TokenRSR as unknown as Web3IconType,
    })),
  ),
  RVST: lazy(() =>
    import(/* webpackExports: ["TokenRVST"] */ '@web3icons/react').then(m => ({
      default: m.TokenRVST as unknown as Web3IconType,
    })),
  ),
  SAITAMA: lazy(() =>
    import(/* webpackExports: ["TokenSAITAMA"] */ '@web3icons/react').then(m => ({
      default: m.TokenSAITAMA as unknown as Web3IconType,
    })),
  ),
  SAND: lazy(() =>
    import(/* webpackExports: ["TokenSAND"] */ '@web3icons/react').then(m => ({
      default: m.TokenSAND as unknown as Web3IconType,
    })),
  ),
  SHIDO: lazy(() =>
    import(/* webpackExports: ["TokenSHIDO"] */ '@web3icons/react').then(m => ({
      default: m.TokenSHIDO as unknown as Web3IconType,
    })),
  ),
  SOCKS: lazy(() =>
    import(/* webpackExports: ["TokenSOCKS"] */ '@web3icons/react').then(m => ({
      default: m.TokenSOCKS as unknown as Web3IconType,
    })),
  ),
  SRK: lazy(() =>
    import(/* webpackExports: ["TokenSRK"] */ '@web3icons/react').then(m => ({
      default: m.TokenSRK as unknown as Web3IconType,
    })),
  ),
  SUSHI: lazy(() =>
    import(/* webpackExports: ["TokenSUSHI"] */ '@web3icons/react').then(m => ({
      default: m.TokenSUSHI as unknown as Web3IconType,
    })),
  ),
  TRU: lazy(() =>
    import(/* webpackExports: ["TokenTRU"] */ '@web3icons/react').then(m => ({
      default: m.TokenTRU as unknown as Web3IconType,
    })),
  ),
  TUSD: lazy(() =>
    import(/* webpackExports: ["TokenTUSD"] */ '@web3icons/react').then(m => ({
      default: m.TokenTUSD as unknown as Web3IconType,
    })),
  ),
  UNI: lazy(() =>
    import(/* webpackExports: ["TokenUNI"] */ '@web3icons/react').then(m => ({
      default: m.TokenUNI as unknown as Web3IconType,
    })),
  ),
  UNIBOT: lazy(() =>
    import(/* webpackExports: ["TokenUNIBOT"] */ '@web3icons/react').then(m => ({
      default: m.TokenUNIBOT as unknown as Web3IconType,
    })),
  ),
  USDC: lazy(() =>
    import(/* webpackExports: ["TokenUSDC"] */ '@web3icons/react').then(m => ({
      default: m.TokenUSDC as unknown as Web3IconType,
    })),
  ),
  USDT: lazy(() =>
    import(/* webpackExports: ["TokenUSDT"] */ '@web3icons/react').then(m => ({
      default: m.TokenUSDT as unknown as Web3IconType,
    })),
  ),
  VEGA: lazy(() =>
    import(/* webpackExports: ["TokenVEGA"] */ '@web3icons/react').then(m => ({
      default: m.TokenVEGA as unknown as Web3IconType,
    })),
  ),
  VIDT: lazy(() =>
    import(/* webpackExports: ["TokenVIDT"] */ '@web3icons/react').then(m => ({
      default: m.TokenVIDT as unknown as Web3IconType,
    })),
  ),
  VIDYA: lazy(() =>
    import(/* webpackExports: ["TokenVIDYA"] */ '@web3icons/react').then(m => ({
      default: m.TokenVIDYA as unknown as Web3IconType,
    })),
  ),
  VLX: lazy(() =>
    import(/* webpackExports: ["TokenVLX"] */ '@web3icons/react').then(m => ({
      default: m.TokenVLX as unknown as Web3IconType,
    })),
  ),
  WBTC: lazy(() =>
    import(/* webpackExports: ["TokenWBTC"] */ '@web3icons/react').then(m => ({
      default: m.TokenWBTC as unknown as Web3IconType,
    })),
  ),
  WHALE: lazy(() =>
    import(/* webpackExports: ["TokenWHALE"] */ '@web3icons/react').then(m => ({
      default: m.TokenWHALE as unknown as Web3IconType,
    })),
  ),
  WRLD: lazy(() =>
    import(/* webpackExports: ["TokenWRLD"] */ '@web3icons/react').then(m => ({
      default: m.TokenWRLD as unknown as Web3IconType,
    })),
  ),
  X2Y2: lazy(() =>
    import(/* webpackExports: ["TokenX2Y2"] */ '@web3icons/react').then(m => ({
      default: m.TokenX2Y2 as unknown as Web3IconType,
    })),
  ),
  YFI: lazy(() =>
    import(/* webpackExports: ["TokenYFI"] */ '@web3icons/react').then(m => ({
      default: m.TokenYFI as unknown as Web3IconType,
    })),
  ),
}
